import { dragging } from 'shared/assets/styles';
import styled, { css } from 'styled-components';

export const SortableContainer = styled.div<{
  $isDragging: boolean;
}>`
  position: relative;

  ${({ $isDragging }) => $isDragging && dragging};
`;

export const Container = styled.div<{
  $isSelected?: boolean;
  $isDisabled?: boolean;
  $isContextMenuOpen?: boolean;
}>`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(1.5)}`};

  border-radius: ${({ theme }) => theme.spacing(2)};

  background: ${({ theme }) => theme.palette.background.default};

  ${({ $isSelected, theme }) =>
    $isSelected &&
    css`
      background: ${theme.palette.background.paper};
    `};

  ${({ $isContextMenuOpen, theme }) =>
    $isContextMenuOpen &&
    css`
      background: ${theme.palette.grey[100]};
    `};

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      pointer-events: none;
    `};
`;

export const CheckboxContainer = styled.div<{ $isFaded?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;

  padding-top: ${({ theme }) => theme.spacing(0.25)};
  width: 2rem;
  height: 2rem;
  min-width: 2rem;
  min-height: 2rem;

  line-height: 62.5%;
  font-size: 2rem;

  ${({ theme }) =>
    theme.isMobile &&
    css`
      width: 3.2rem;
      height: 3.2rem;
      min-width: 3.2rem;
      min-height: 3.2rem;
    `};

  ${({ $isFaded }) =>
    $isFaded &&
    css`
      opacity: 0.3;
    `};
`;

export const TitleContainer = styled.div<{ $isFaded?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.75)};
  min-width: 0;

  line-height: 1;

  ${({ $isFaded, theme }) =>
    $isFaded &&
    css`
      opacity: 0.5;
      color: ${theme.palette.text.secondary};
    `}

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding-top: ${({ theme }) => theme.spacing(1.5)};
    `};
`;
